import { ENDPOINTS } from "./endpoints";
import {
  mockBranches, mockSalesSummary, mockSalesByHour, mockSalesByDay,
  mockProductsRanking, mockCustomersStats, mockOrdersByCustomer,
  mockAvgTicket, mockCancellations, mockHeatmap
} from "./mock";

// Cambia esto para activar API real
const CONFIG = { 
  USE_LIVE_API: true, 
  BASE_URL: "https://grupomn.net/app/lcr/api/index.php/report"
};

// helper querystring
function qs(params){
  const sp = new URLSearchParams();
  Object.keys(params||{}).forEach(k=>{
    const v = params[k];
    if(v !== undefined && v !== null && v !== "") sp.append(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : "";
}

async function fetchJson(url){
  const res = await fetch(url, {
    method: "GET",
    headers: { "Content-Type":"application/json" }
  });
  if(!res.ok){
    const txt = await res.text().catch(()=> "");
    
    throw new Error(`HTTP ${res.status} ${res.statusText} :: ${txt}`);
  }
    
  return res.json();
}

// API pública (lo que consume el dashboard)
export const Api = {
  config: CONFIG,

  async branches(){
    if(!CONFIG.USE_LIVE_API) return mockBranches();
    return fetchJson(CONFIG.BASE_URL + ENDPOINTS.branches);
  },

 salesSummary: async (params) => {
  const res = await fetchJson(CONFIG.BASE_URL + "/resumen" + qs(params));
  const rows = res.data ? res.data : res;

  const r = Array.isArray(rows) && rows.length ? rows[0] : {};

  return {
    totalVentas: Number(r.totalVentas || 0),
    pedidos: Number(r.pedidos || 0),
    ticketPromedio: Number(r.ticketPromedio || 0),
    clientesNuevos: Number(r.clientesNuevos || 0),
    cancelaciones: Number(r.cancelaciones || 0),
    devoluciones: Number(r.devoluciones || 0)
  };
},

  salesByHour: async (params) => {
    const res = await fetchJson(CONFIG.BASE_URL + "/por_hora" + qs(params));
    const rows = res.data ? res.data : res;

    return {
        labels: Array.isArray(rows)
        ? rows.map(r => String(r.hora).padStart(2,"0") + ":00")
        : [],
        values: Array.isArray(rows)
        ? rows.map(r => Number(r.cantidad))
        : []
    };
    },

  salesByDay: async (params) => {
    const res = await fetchJson(CONFIG.BASE_URL + "/por_dia" + qs(params));
    const rows = res.data ? res.data : res;

    return {
        labels: Array.isArray(rows)
        ? rows.map(r => r.fecha)
        : [],
        values: Array.isArray(rows)
        ? rows.map(r => Number(r.ventas))
        : []
    };
    },

  async productsRanking(params){
    if(!CONFIG.USE_LIVE_API) return mockProductsRanking(params);
    return fetchJson(CONFIG.BASE_URL + ENDPOINTS.productsRanking + qs(params));
  },

  async customersStats(params){
    if(!CONFIG.USE_LIVE_API) return mockCustomersStats(params);
    return fetchJson(CONFIG.BASE_URL + ENDPOINTS.customersStats + qs(params));
  },

  async ordersByCustomer(params){
    if(!CONFIG.USE_LIVE_API) return mockOrdersByCustomer(params);
    return fetchJson(CONFIG.BASE_URL + ENDPOINTS.ordersByCustomer + qs(params));
  },

  async avgTicket(params){
    if(!CONFIG.USE_LIVE_API) return mockAvgTicket(params);
    //return fetchJson(CONFIG.BASE_URL + ENDPOINTS.avgTicket + qs(params));

    console.log( fetchJson(CONFIG.BASE_URL + ENDPOINTS.avgTicket + qs(params)));
  },

  async cancellations(params){
    if(!CONFIG.USE_LIVE_API) return mockCancellations(params);
    return fetchJson(CONFIG.BASE_URL + ENDPOINTS.cancellations + qs(params));
  },

  heatmap: async (params) => {
    const res = await fetchJson(CONFIG.BASE_URL + "/heatmap" + qs(params));
    return res.data;
    }
};
